var React = require('react');

function ArrowCollapse (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.68333 14L11.5 5.2973L20.3167 14L23 11.3514L11.5 9.01987e-07L-1.6758e-06 11.3513L2.68333 14Z","fill":"#83EABF"}));
}

ArrowCollapse.defaultProps = {"width":"23","height":"14","viewBox":"0 0 23 14","fill":"none"};

module.exports = ArrowCollapse;

ArrowCollapse.default = ArrowCollapse;
